import { bsc } from "wagmi/chains";


export const contract = {
  97: {
    STAKE_ADDRESS: "0x9702831f95207d26a495541bed8501062943c923",
    MULTICALL_ADDRESS: "0xa54fE4a3DbD1Eb21524Cd73754666b7E13b4cB18",
    TOKEN_ADDRESS: "0xC7b6278c411564729c02548A5742E6D5788BAc33",
    DTC_ADDRESS : "0xa733649066D32aeA81849a3927b19EeEa19d3521"
  },
  56: {
    STAKE_ADDRESS: "0x862f263745f6c6c784bea27fe232b788a5be3cf2",
    MULTICALL_ADDRESS: "0x2cc8fe3e04d7b1edaeb42e2e73f78c4cac074116",
    TOKEN_ADDRESS: "0x55d398326f99059fF775485246999027B3197955",
    DTC_ADDRESS : "0x807e24398591DC7AaB77E2E19dAcC40Ac6d18dF5"
  }
}

export const DEFAULT_CHAIN = 56;
export const DEFAULT_RPC = "https://bsc-dataseed1.binance.org/"
// export const DEFAULT_RPC = "https://data-seed-prebsc-2-s1.binance.org:8545/"
export const PROJECT_ID = "27b9720018bf7f8740936e6a6eb28604";
export const DECIMALS = 18;
export const SYMBOL = 'USDT';
export const EXPLOER = 'https://bscscan.com/';
export const chains = [bsc]
export const AOMZ_IMG = "https://etherscan.io/token/images/tethernew_32.svg"
export const DTC_IMG = "https://alchemy.mypinata.cloud/ipfs/QmWMXSkvhn9f4PvsPY1osgKZC6dNbpNumEdLYcojL3BLyj"






